/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import Dispatcher from '../../dispatcher';
import { AddToDocumentMenuOption, TranscribingActionTypes} from '../../common/enums/transcribingEnums';
import { ITranscriptionManager } from '../../../backend/interfaces/ITranscriptionManager';
import { TranscribingEntryPoints } from '../../../AppConstants';

export function getAddToDocumentOptionsFromMenuOption(menuOption: AddToDocumentMenuOption) {
  switch (menuOption) {
    case AddToDocumentMenuOption.JustText:
      return { withTimestamps: false, withSpeakers: false }
    case AddToDocumentMenuOption.WithSpeakers:
      return { withTimestamps: false, withSpeakers: true }
    case AddToDocumentMenuOption.WithTimestamps:
      return { withTimestamps: true, withSpeakers: false }
    default:
      return { withTimestamps: true, withSpeakers: true }
  }
}

export function SetEditingMode(index?: number) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetEditingIndexAction,
    payload: index
  });
}

export function SetFocusedIndex(index?: number) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetFocusedIndexAction,
    payload: index
  });
}

export function SetTeachingUIClosedFlag(flag: boolean) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetTeachingUIClosedFlag,
    payload: flag
  });
}

export function SetAddToDocumentInProgressStatus(flag: boolean) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetAddToDocumentInProgressStatus,
    payload: flag
  });
}

export function SetAudioPlaying(flag: boolean) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetAudioPlayingFlag,
    payload: flag
  });
}

export function SetShowStartOverConfirmDialog(flag: boolean) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetShowStartOverConfirmDialog,
    payload: flag
  });
}

export function GetSpeakerName(speakerId: number | undefined | null, speakerNames: (string | null)[] | undefined): string {
  if (speakerId == null)
    return TranscriptionStrings.DefaultNameForSpeaker;

  if (speakerNames == null || speakerNames[speakerId] == null)
    return `${TranscriptionStrings.DefaultNameForSpeaker} ${speakerId + 1}`;

  return speakerNames[speakerId]!;
}

export function SetHighlightedIndex(index: number) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetHighlightedIndexAction,
    payload: index
  });
}

export function SetTranscriptionManager(transcriptionManager: ITranscriptionManager) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetTranscriptionManager,
    payload: transcriptionManager
  });
}

export function SetTranscribingEntryPoints(transcribingEntryPoint: TranscribingEntryPoints) {
  Dispatcher.dispatch({
    type: TranscribingActionTypes.SetTranscriptionEntryPoints,
    payload: transcribingEntryPoint
  });
}
